import { FaBarsStaggered } from "react-icons/fa6";
import { useEffect, useState } from "react";
import Breadcrumb from "../Breadcrumbs/Breadcrumb";
import { AiOutlineLogout } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import ConfirmDeleteModal from "../../common/DeleteModel";

const Header = ({ sidebarOpen, setSidebarOpen, sidebarCollapsed }) => {
  const navigate = useNavigate();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const confirmLogout = () => {
    setIsDeleteModalOpen(true);
  };

  const doLogout = () => {
    sessionStorage.clear();
    navigate("/login");
  };

  return (
    <>
      <header
        className={`fixed top-0 right-0 z-30 flex h-16 w-full bg-white shadow-sm transition-all duration-300 ${
          sidebarCollapsed
            ? "lg:w-[calc(100%-64px)]"
            : "lg:w-[calc(100%-224px)]"
        }`}
      >
        <div className="flex w-full items-center justify-between px-4 lg:px-8">
          <div className="flex items-center gap-4">
            <button
              onClick={() => setSidebarOpen(!sidebarOpen)}
              className="lg:hidden p-2 text-gray-600 hover:bg-gray-100 rounded-lg"
            >
              <FaBarsStaggered size={20} />
            </button>

            <div className="hidden sm:block">
              <Breadcrumb />
            </div>
          </div>

          <div className="flex items-center gap-3">
            <button
              onClick={confirmLogout}
              className="flex items-center gap-2 px-4 py-2 bg-red-50 text-red-600 hover:bg-red-100 rounded-full transition-colors font-medium text-sm"
            >
              <AiOutlineLogout size={18} />
              <span className="hidden md:inline">Logout</span>
            </button>
          </div>
        </div>
        <ConfirmDeleteModal
          isOpen={isDeleteModalOpen}
          onClose={() => setIsDeleteModalOpen(false)}
          onConfirm={doLogout}
          onConfirmTitle="Confirm, Log Out"
        />
      </header>
    </>
  );
};

export default Header;
